import { createSvgIcon } from '@automata/mui-theme';
export const BmgPherastarIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.977 67.5129L16.7598 70.8651L23.023 74.4869L28.2403 71.1347L21.977 67.5129ZM22.4228 64.3052L32.5807 70.1792C33.2287 70.5539 33.2504 71.4815 32.6207 71.8861L23.6184 77.6702C23.3033 77.8726 22.9015 77.8821 22.5773 77.6946L12.4193 71.8206C11.7713 71.4459 11.7496 70.5183 12.3794 70.1136L21.3816 64.3296C21.6967 64.1271 22.0985 64.1177 22.4228 64.3052Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85 64.439C85 64.7874 84.8187 65.1106 84.5215 65.2923L49.5042 86.6917C49.1932 86.8818 48.8034 86.8876 48.4869 86.7068L27.8735 74.9361L30.7203 73.107L48.9482 83.5156L82 63.3173V29.7075L52.9767 12.475L22.2014 30.1941L19 35.7965V65.8597L16.0199 67.7744C16.0068 67.7096 16 67.6431 16 67.5756V35.2654C16 35.0914 16.0454 34.9204 16.1318 34.7693L19.8656 28.2351C19.9536 28.081 20.0811 27.9532 20.2348 27.8646L52.4933 9.29158C52.8063 9.11135 53.1922 9.11394 53.5028 9.29835L84.5105 27.7092C84.814 27.8894 85 28.2162 85 28.5691V64.439Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.4919 45.8437L21.4962 28.1318L20.5039 29.8683L52.5081 48.1565L83.5083 29.8613L82.4918 28.1389L52.4919 45.8437Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.6141 51.119L18.5023 33.6348L17.498 35.3643L49.3863 53.8801L52.8781 47.4784L51.1223 46.5207L48.6141 51.119Z"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M50 52V84H48V52H50Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M76.5077 48.9872C77.841 48.2253 79.5 49.188 79.5 50.7237V61.4322C79.5 62.137 79.1291 62.7897 78.5236 63.1504L57.0236 75.9589C55.6905 76.7531 54 75.7925 54 74.2407V69.3484C54 68.8978 54.1522 68.4603 54.4319 68.107L63.5959 56.5314C63.7545 56.3311 63.95 56.163 64.1717 56.0363L76.5077 48.9872ZM77.5 50.7237L65.164 57.7728L56 69.3484L56 74.2407L77.5 61.4322V50.7237Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 42.291L34 49.5968V62.7092L21 55.4034V49.5722L22 50.0873V48.5268L21 47.4965V42.291ZM23 52.8523V54.2332L32 59.291V50.767L23 45.7092V46.6855L24 47.7158V53.3674L23 52.8523Z"
    />
  </svg>,
  'BmgPherastarIcon'
);
